import React, { useState } from "react";

import styles from "./UKCConformationResults.module.scss";

interface IProps {
  title: string;
  meta?: string;
  defaultOpen?: boolean;
  tone?: "default" | "show";
  children: React.ReactNode;
}

export const NestedSection: React.FC<IProps> = ({ title, meta, defaultOpen = false, tone = "default", children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`${styles.section} ${tone === "show" ? styles.showTone : ""}`}>
      <div
        className={`${styles.sectionHeader} ${open ? styles.open : ""} ${tone === "show" ? styles.showHeader : ""}`}
        onClick={() => setOpen((value) => !value)}
      >
        <span>
          <span className={styles.sectionTitle}>{title}</span>
          {meta ? <span className={styles.sectionMeta}>{meta}</span> : null}
        </span>
        <span className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}>▾</span>
      </div>
      {open ? <div className={styles.sectionBody}>{children}</div> : null}
    </div>
  );
};
